class ImageConverter {

    public getImageUrl(type: string, value: string): string {
        let result = null;
        switch (type) {
            case 'activity':
                result = this.getActivityImageUrl(value);
                break;
            case 'profile':
                result = this.getProfileImageUrl(value);
                break;
            case 'rank':
                result = this.getRankImageUrl(parseInt(value, 10));
                break;
            case 'kom':
                result = this.getKomImageUrl(parseInt(value, 10));
                break;
        }
        return result;
    }

    public getRankImageUrl(rank: number): string {
        let image = null;
        switch (rank) {
            case 1:
                image = this.getImage('icons/rank_1.png');
                break;
            case 2:
                image = this.getImage('icons/rank_2.png');
                break;
            case 3:
                image = this.getImage('icons/rank_3.png');
                break;
        }
        return image;
    }

    public getKomImageUrl(rank: number): string {
        let image = null;
        switch (rank) {
            case 1:
                image = this.getImage('icons/kom_crown.png');
                break;
            default:
                image = this.getImage('icons/kom_cup.png');
                break;
        }
        return image;
    }

    public getProfileImageUrl(activityType: string): string {
        let image = null;
        switch (activityType) {
            case 'flat':
                image = this.getImage('icons/road.png');
                break;
            case 'traverse':
                image = this.getImage('icons/traverse.png');
                break;
            case 'downhill':
                image = this.getImage('icons/downhill.png');
                break;
            case 'steep_downhill':
                image = this.getImage('icons/sport/dh_helmet.png');
                break;
            case 'climb-1':
                image = this.getImage('icons/climb_1.png');
                break;
            case 'climb-2':
                image = this.getImage('icons/climb_2.png');
                break;
            case 'climb-3':
                image = this.getImage('icons/climb_3.png');
                break;
            case 'climb-4':
                image = this.getImage('icons/climb_4.png');
                break;
            case 'climb-hc':
                image = this.getImage('icons/climb_hc.png');
                break;
            case 'uphill':
                image = this.getImage('icons/uphill.png');
                break;
            default:
                image = this.getImage('icons/question.png');
                break;
        }
        return image;
    }

    public getActivityImageUrl(activityType: string): string {
        let imageName = this.getImage('icons/sport/run.png');
        switch (activityType) {
            case 'Ride':
                imageName = this.getImage('icons/sport/ride.png');
                break;
            case 'Run':
                imageName = this.getImage('icons/sport/run.png');
                break;
            case 'Swim':
                imageName = this.getImage('icons/sport/swim.png');
                break;
            case 'Hike':
                imageName = this.getImage('icons/sport/hike.png');
                break;
            case 'Walk':
                imageName = this.getImage('icons/sport/walk.png');
                break;
            case 'NordicSki':
            case 'BackcountrySki':
                imageName = this.getImage('icons/sport/backcountry_ski.png');
                break;
            case 'AlpineSki':
                imageName = this.getImage('icons/sport/alpine_ski.png');
                break;
            case 'IceSkate':
            case 'InlineSkate':
            case 'RollerSki':
                imageName = this.getImage('icons/sport/skate.png');
                break;
            case 'Kitesurf':
                imageName = this.getImage('icons/sport/kite_surf.png');
                break;
            case 'Windsurf':
                imageName = this.getImage('icons/sport/wind_surf.png');
                break;
            case 'Workout':
            case 'WeightTraining':
                imageName = this.getImage('icons/sport/workout.png');
                break;
            case 'Snowboard':
                imageName = this.getImage('icons/sport/snowboard.png');
                break;
            case 'Snowshoe':
                imageName = this.getImage('icons/sport/snowshoe.png');
                break;
            case 'Canoeing':
                imageName = this.getImage('icons/sport/canoeing.png');
                break;
            case 'Crossfit':
                imageName = this.getImage('icons/sport/dumbells.png');
                break;
            case 'EBikeRide':
                imageName = this.getImage('icons/sport/ebike.png');
                break;
            case 'Elliptical':
            case 'StairStepper':
                imageName = this.getImage('icons/sport/xtrainer.png');
                break;
            case 'Kayaking':
                imageName = this.getImage('icons/sport/kayak.png');
                break;
            case 'RockClimbing':
                imageName = this.getImage('icons/sport/rock_climbing.png');
                break;
            case 'Rowing':
                imageName = this.getImage('icons/sport/rowing.png');
                break;
            case 'StandUpPaddling':
                imageName = this.getImage('icons/sport/paddle_surf.png');
                break;
            case 'Surfing':
                imageName = this.getImage('icons/sport/surf.png');
                break;
            case 'VirtualRide':
                imageName = this.getImage('icons/sport/virtual_ride.png');
                break;
            case 'Yoga':
                imageName = this.getImage('icons/sport/yoga.png');
                break;
            case 'Unknown':
                imageName = this.getImage('icons/sport/run.png');
                break;
        }
        return imageName;
    }

    private getImage(name: string) {
        // the require loads the webpack base64 coverted images
        return require(`../assets/${name.toLowerCase()}`);
    }
}


const ic = new ImageConverter();

export default ic;
